var e={flexDirection:{value:"column"}};export{e as selectfield};
